import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=44686ef2&scoped=true&lang=pug"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&id=44686ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44686ef2",
  null
  
)

export default component.exports